import { createGlobalState } from "react-hooks-global-state";
import { v4 as uuid } from "uuid";
import { AlertColor } from "@mui/material/Alert";

export type GlobalAlert = {
  id: string;
  title?: string;
  message: string;
  severity?: AlertColor;
  closed: boolean;
};

const initState: {
  alerts: Record<string, GlobalAlert>;
} = {
  alerts: {
    // haha: {
    //   id: "haha",
    //   message: "Your account was deleted. Please come back soon!",
    //   severity: "success",
    //   closed: false,
    // },
  },
};

export const { useGlobalState, getGlobalState, setGlobalState } =
  createGlobalState(initState);

const closeAllAlerts = (): void => {
  const alerts = getGlobalState("alerts");
  const closedAlerts = Object.values(alerts).map((alert) => ({
    ...alert,
    closed: true,
  }));
  setGlobalState(
    "alerts",
    Object.fromEntries(closedAlerts.map((a) => [a.id, a]))
  );
};

export const createAlert = (
  alertWithoutId: Omit<GlobalAlert, "id" | "closed">
): void => {
  console.log("createAlert", { alertWithoutId });
  // always close existing alerts when opening a new one
  closeAllAlerts();

  const id = uuid();
  const alert: GlobalAlert = { ...alertWithoutId, closed: false, id };
  // automatically close the alert in 5 seconds
  setTimeout(() => {
    console.log("auto close alert", { alert });
    const alertLatest = getGlobalState("alerts")[id];
    if (alertLatest.closed) return;
    // only update the alert if it's still open to avoid re-render
    updateAlert(id, { ...alertLatest, closed: true });
  }, 5000);
  setGlobalState("alerts", { ...getGlobalState("alerts"), [id]: alert });
};

export const updateAlert = (id: string, newAlertValue: GlobalAlert): void => {
  setGlobalState("alerts", {
    ...getGlobalState("alerts"),
    [id]: newAlertValue,
  });

  console.log("updated alert", { id, newAlertValue });
};
